import { render, staticRenderFns } from "./SelectFish.vue?vue&type=template&id=c4b945ee&"
import script from "./SelectFish.vue?vue&type=script&lang=js&"
export * from "./SelectFish.vue?vue&type=script&lang=js&"
import style0 from "./SelectFish.vue?vue&type=style&index=0&id=c4b945ee&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports